<template>
  <el-dialog
      title="确认删除"
      :visible="dialogDelete"
  width="400px"
  :before-close="handleClose"
  >
  <span>{{ message }}</span>

  <template #footer>
    <el-button @click="closeDialog">取消</el-button>
    <el-button type="primary" @click="confirmDelete">确认删除</el-button>
  </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    // 使用父组件传递过来的 visible 属性
    visible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '您确定要删除此项吗？删除后无法恢复。',
    },
  },
  data() {
    return {
      dialogDelete: this.visible, // 使用父组件传递的值初始化
    };
  },
  watch: {
    visible(newVal) {
      this.dialogDelete = newVal;
    },
    dialogDelete(newVal) {
      this.$emit('update:visible', newVal); // 更新父组件的 visible
    },
  },
  methods: {
    handleClose(done) {
      this.$emit('update:visible', false);  // 父组件要接收到更新
      done();
    },
    closeDialog() {
      this.dialogDelete = false;
    },
    confirmDelete() {
      this.$emit('confirm-delete');  // 触发父组件的删除逻辑
      this.dialogDelete = false; // 关闭弹窗
    },
  },
};
</script>
